<template>
  <div :id="componentId" class="sp1-organizations" :style="sectionStyle">
    <div class="sp1-org-list">
      <a
        v-for="(item, idx) in items"
        :key="idx"
        :class="['sp1-org-item', { 'is-link': item.jumpType === 2 }]"
        href="javascript:;"
        @click.prevent="handleClick(item)"
      >
        <img
          class="sp1-org-image"
          referrerpolicy="no-referrer"
          :src="item.imageUrl"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Organizations',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_13'
    }
  },
  data() {
    return {
      backgroundImage: require('../assets/img/bottom_bg.png'),
      items: [
        {
          imageUrl: require('../assets/img/organizations_card.png'),
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../assets/img/organizations_card.png'),
          jumpType: 2,
          linkAddress: 'https://www.example.com/org/2'
        },
        {
          imageUrl: require('../assets/img/organizations_card.png'),
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../assets/img/organizations_card.png'),
          jumpType: 2,
          linkAddress: 'https://www.example.com/org/4'
        }
      ]
    };
  },
  computed: {
    sectionStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '2000px',
        marginLeft: '-300px',
         padding: '20px 300px',
        boxSizing: 'border-box'
      };
    },
    titleGroupStyle() {
      return {
        margin: '0px auto 0',
        width: '360px',
        height: '70px',
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    }
  },
  methods: {
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return;
      window.open(item.linkAddress, '_blank');
    }
  }
};
</script>

<style scoped>
.sp1-organizations {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
  padding-top: 30px;
  padding-bottom: 30px;
}

.sp1-group_69 .sp1-text_9 {
  margin: 0;
  width: auto;
  height: auto;
  text-align: center;
  line-height: 1;
}

.sp1-org-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 20px;
}

.sp1-org-item {
  display: block;
  width: 663px;
  height: 147px;
}

.sp1-org-item.is-link {
  cursor: pointer;
}

.sp1-org-item.is-link:hover {
  opacity: 0.9;
}

.sp1-org-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
